"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_css_themr_1 = require("react-css-themr");
const Markdown_1 = require("../Markdown");
exports.DumpHeading = ({ data: { title, subtitle, useMarkdown, titleTag: TitleTag = 'h1', subtitleTag: SubtitleTag = 'h2', }, theme = {}, ...rest }) => (React.createElement("div", Object.assign({ className: theme.root }, rest),
    title && (React.createElement(TitleTag, { className: theme.title }, useMarkdown ? React.createElement(Markdown_1.default, { value: title }) : title)),
    subtitle && (React.createElement(SubtitleTag, { className: theme.subtitle }, useMarkdown ? React.createElement(Markdown_1.default, { value: subtitle }) : subtitle)),
    React.createElement("div", { className: theme.separator })));
exports.defaultHeadingTheme = {
    root: 'tc ph2 mb3',
    title: 'f3 f2-ns pc ttu ma0 pt4 pc-dark fw9',
    subtitle: 'f4 f3-ns pc-dark fw4 ma0 pt1 pb2',
};
const Heading = react_css_themr_1.themr('Heading', {}, { composeTheme: 'softly' })(exports.DumpHeading);
exports.default = Heading;
//# sourceMappingURL=index.js.map